import { render, staticRenderFns } from "./StudyQuizQuestionPayment.vue?vue&type=template&id=c097dc94"
import script from "./StudyQuizQuestionPayment.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports